export const arePropsEqual = (prevProps, nextProps) => (
    prevProps.tabKey === nextProps.tabKey &&
    prevProps.shouldFetch === nextProps.shouldFetch &&
    prevProps.filterData.categoryId === nextProps.filterData.categoryId &&
    JSON.stringify(prevProps.filterData.mainFilterGroupIds) === 
      JSON.stringify(nextProps.filterData.mainFilterGroupIds) &&
    JSON.stringify(prevProps.filterData.comparisonFilterGroupIds) === 
      JSON.stringify(nextProps.filterData.comparisonFilterGroupIds)
  );